var scrollToElement = require("scroll-to-element");

export function upravStranku() {
  $("#dvScrollMenu ul a").click(function(e) {
    let a = $(this);

    // with options
    scrollToElement(a.attr("href"), {
      offset: -40,
      ease: "in-quad", //out-bounce
      duration: 800
    }).on("end", () => {
      $("#dvScrollMenu").removeClass("show");
      //console.log("Done scrolling!");
    });

    e.preventDefault();
  });
} //function  upravStranku()
